import React, { useEffect, useMemo, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import { GIDER_KALEMLERI, PERSONEL_GIDER_KALEMLERI } from '../../utils/finance/financeCostConstants';
import { fxPrimaryBtnSx } from './financeTheme';

const empty = () => ({
  title: 'Kira',
  category: 'kira',
  amountTry: '',
  description: '',
  personelId: '',
  personelName: ''
});

export default function ExpenseModal({ open, onClose, onSave, initial, personeller }) {
  const [form, setForm] = useState(empty());
  useEffect(() => {
    if (!open) return;
    if (initial) {
      setForm({
        title: initial.title || '',
        category: initial.category || 'diger',
        amountTry: initial.amountTry ?? '',
        description: initial.description || '',
        personelId: initial.personelId || '',
        personelName: initial.personelName || ''
      });
    } else {
      setForm(empty());
    }
  }, [open, initial]);

  const showPersonel = PERSONEL_GIDER_KALEMLERI.includes(form.category);
  const personelOptions = useMemo(() => personeller || [], [personeller]);

  const setCat = (category) => {
    const def = GIDER_KALEMLERI.find((k) => k.id === category);
    setForm((p) => ({
      ...p,
      category,
      title: !p.title || p.title === GIDER_KALEMLERI.find((k) => k.id === p.category)?.label
        ? (def?.label || p.title)
        : p.title
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800, fontSize: 16 }}>{initial ? 'Gideri Düzenle' : 'Gider Ekle'}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, pt: '12px !important' }}>
        <FormControl size="small">
          <InputLabel>Kategori</InputLabel>
          <Select label="Kategori" value={form.category} onChange={(e) => setCat(e.target.value)}>
            {GIDER_KALEMLERI.map((k) => <MenuItem key={k.id} value={k.id}>{k.label}</MenuItem>)}
          </Select>
        </FormControl>
        <TextField size="small" label="Gider adı" value={form.title} onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))} />
        <TextField
          size="small"
          label="Aylık tutar"
          value={form.amountTry}
          onChange={(e) => setForm((p) => ({ ...p, amountTry: e.target.value }))}
          helperText="Günlük pay = aylık tutar ÷ ayın gün sayısı. 30.000 ₺ kira → 1.000 ₺ / gün."
        />
        {showPersonel ? (
          <FormControl size="small">
            <InputLabel>Personel</InputLabel>
            <Select
              label="Personel"
              value={form.personelId}
              onChange={(e) => {
                const p = personelOptions.find((x) => x.id === e.target.value);
                setForm((prev) => ({
                  ...prev,
                  personelId: e.target.value,
                  personelName: p ? `${p.isim || ''} ${p.soyisim || ''}`.trim() : ''
                }));
              }}
            >
              <MenuItem value="">—</MenuItem>
              {personelOptions.map((p) => (
                <MenuItem key={p.id} value={p.id}>{`${p.isim || ''} ${p.soyisim || ''}`.trim()}</MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
        <TextField size="small" label="Açıklama" value={form.description} onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Vazgeç</Button>
        <Button variant="contained" onClick={() => onSave(form)} sx={fxPrimaryBtnSx}>Kaydet</Button>
      </DialogActions>
    </Dialog>
  );
}
